import { Component, inject } from '@angular/core';
import { AdminSettingsEntryComponent } from '@app/admin/settings/admin-settings-entry/admin-settings-entry.component';
import { AdminSettingsNewComponent } from '@app/admin/settings/admin-settings-new/admin-settings-new.component';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';
import { rxResource } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-admin-settings',
  templateUrl: './admin-settings.component.html',
  imports: [
    AdminSettingsEntryComponent,
    AdminSettingsNewComponent,
    TranslatePipe,
  ],
})
export class AdminSettingsComponent {
  private readonly backendService = inject(BackendService);

  settings = rxResource({ defaultValue: [], stream: () => this.backendService.listSettings() });

  onSettingDeleted(id: number) {
    this.settings.update( list =>
      list.filter( setting => setting.id !== id )
    );
  }
}
